export class ValidationResult {

    success: boolean = false;
    message: string;

    public setValidResult() {

        this.success = true;
        this.message = null;

    }

    public setInvalidResult(message: string) {

        this.success = false;
        this.message = message;

    }

}
